import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less']
})

export class LoaderComponent  {
  constructor(private loaderService : LoaderService) { }

  isLoading : Subject<boolean> = this.loaderService.isLoading;

  ngOnInit() {
  }

}
